module.exports = __webpack_public_path__ + "static/q16_o-f2b7ead3791ab3012b4efd303e21740d.png";